import SpriteSymbol from "../../../../../common/temp/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../tools/svg-sprite.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-loading",
  "use": "icon-icon-loading-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 20\" id=\"icon-icon-loading\"><path fill=\"currentColor\" d=\"M7.287 3.91a6.667 6.667 0 1 1-3.954 6.094v-.69a.833.833 0 0 0-1.666 0v.69a8.335 8.335 0 0 0 15.324 4.532A8.333 8.333 0 0 0 6.608 2.388a.833.833 0 0 0 .679 1.522Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol